import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { ArrowRight, CheckCircle, Copy, Check, MessageSquare, Smartphone, Share2, Heart, Clock, FileText, Forward, Zap, UserPlus, History, Send, Play } from 'lucide-react';
import { Link } from 'react-router-dom';
export function RelationshipLandingPage() {
  const [copied, setCopied] = useState(false);
  const phoneNumber = '(774) 472-7423';
  const smsHref = `sms:+1${phoneNumber.replace(/\D/g, '')}?body=Hi%20ScribeTok!%20I%20want%20to%20transcribe%20a%20video.`;
  const handleCopyNumber = () => {
    navigator.clipboard.writeText(phoneNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="min-h-screen w-full bg-background px-4 py-12 md:px-16 lg:px-32 flex flex-col items-center justify-center overflow-x-hidden" data-id="element-638">
      <div className="w-full max-w-4xl mx-auto text-center" data-id="element-639">
        {/* Logo */}
        <div className="flex justify-center mb-6" data-id="element-640">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6tsscMEhsZ3L4JwT2r374e/ScribeTok-logo.png" alt="ScribeTok Logo" className="h-14 w-auto" data-id="element-641" />
        </div>
        {/* Hero Section */}
        <div className="mb-2" data-id="element-642">
          <span className="inline-block bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-643">
            Watch → Read → Connect
          </span>
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 animate-slide-down" style={{
        animationDelay: '100ms'
      }} data-id="element-644">
          Sick of Your Partner{' '}
          <span className="text-primary" data-id="element-645">Ignoring Your TikToks?</span>
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8 animate-slide-down" style={{
        animationDelay: '200ms'
      }} data-id="element-646">
          With ScribeTok, you can send them a transcript to guarantee they'll
          get the point—no headphones, no app, no wait.
        </p>
        {/* Problem/Solution Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 animate-scale" style={{
        animationDelay: '300ms'
      }} data-id="element-647">
          {/* Problem Card */}
          <Card className="text-left" data-id="element-648">
            <CardContent className="p-6" data-id="element-649">
              <h3 className="text-xl font-medium mb-4 flex items-center" data-id="element-650">
                <Clock size={20} className="text-primary mr-2" data-id="element-651" />
                The Problem
              </h3>
              <ul className="space-y-3" data-id="element-652">
                <li className="flex items-start gap-3" data-id="element-653">
                  <div className="w-6 h-6 rounded-full bg-destructive/20 flex items-center justify-center text-destructive flex-shrink-0 mt-0.5" data-id="element-654">
                    ✗
                  </div>
                  <p className="text-muted-foreground" data-id="element-655">
                    <span className="font-medium text-foreground" data-id="element-656">
                      TikToks get lost in chat
                    </span>{' '}
                    — never actually watched
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-657">
                  <div className="w-6 h-6 rounded-full bg-destructive/20 flex items-center justify-center text-destructive flex-shrink-0 mt-0.5" data-id="element-658">
                    ✗
                  </div>
                  <p className="text-muted-foreground" data-id="element-659">
                    <span className="font-medium text-foreground" data-id="element-660">
                      "I'll watch it later"
                    </span>{' '}
                    — but they never do
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-661">
                  <div className="w-6 h-6 rounded-full bg-destructive/20 flex items-center justify-center text-destructive flex-shrink-0 mt-0.5" data-id="element-662">
                    ✗
                  </div>
                  <p className="text-muted-foreground" data-id="element-663">
                    <span className="font-medium text-foreground" data-id="element-664">
                      Micro-friction in relationships
                    </span>{' '}
                    — "Did you see that thing I sent?"
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-665">
                  <div className="w-6 h-6 rounded-full bg-destructive/20 flex items-center justify-center text-destructive flex-shrink-0 mt-0.5" data-id="element-666">
                    ✗
                  </div>
                  <p className="text-muted-foreground" data-id="element-667">
                    <span className="font-medium text-foreground" data-id="element-668">
                      Wrong moment to watch
                    </span>{' '}
                    — in meetings, public places, or busy
                  </p>
                </li>
              </ul>
            </CardContent>
          </Card>
          {/* Solution Card */}
          <Card className="text-left" data-id="element-669">
            <CardContent className="p-6" data-id="element-670">
              <h3 className="text-xl font-medium mb-4 flex items-center" data-id="element-671">
                <Zap size={20} className="text-primary mr-2" data-id="element-672" />
                The Solution
              </h3>
              <ul className="space-y-3" data-id="element-673">
                <li className="flex items-start gap-3" data-id="element-674">
                  <div className="w-6 h-6 rounded-full bg-success/20 flex items-center justify-center text-success flex-shrink-0 mt-0.5" data-id="element-675">
                    ✓
                  </div>
                  <p className="text-muted-foreground" data-id="element-676">
                    <span className="font-medium text-foreground" data-id="element-677">
                      Convert TikToks to text
                    </span>{' '}
                    — instantly readable
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-678">
                  <div className="w-6 h-6 rounded-full bg-success/20 flex items-center justify-center text-success flex-shrink-0 mt-0.5" data-id="element-679">
                    ✓
                  </div>
                  <p className="text-muted-foreground" data-id="element-680">
                    <span className="font-medium text-foreground" data-id="element-681">
                      Share the TikTok WITH the transcript
                    </span>{' '}
                    — context plus content
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-682">
                  <div className="w-6 h-6 rounded-full bg-success/20 flex items-center justify-center text-success flex-shrink-0 mt-0.5" data-id="element-683">
                    ✓
                  </div>
                  <p className="text-muted-foreground" data-id="element-684">
                    <span className="font-medium text-foreground" data-id="element-685">
                      Guaranteed engagement
                    </span>{' '}
                    — they can read even if they can't watch
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-686">
                  <div className="w-6 h-6 rounded-full bg-success/20 flex items-center justify-center text-success flex-shrink-0 mt-0.5" data-id="element-687">
                    ✓
                  </div>
                  <p className="text-muted-foreground" data-id="element-688">
                    <span className="font-medium text-foreground" data-id="element-689">
                      Strengthen connections
                    </span>{' '}
                    — share what matters, how it matters
                  </p>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
        {/* How It Works */}
        <div className="mb-12 animate-fade-in" style={{
        animationDelay: '400ms'
      }} data-id="element-690">
          <h2 className="text-2xl font-bold mb-6" data-id="element-691">How It Works</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-692">
            <div className="flex flex-col items-center text-center p-4" data-id="element-693">
              <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mb-4" data-id="element-694">
                <MessageSquare size={24} className="text-primary" data-id="element-695" />
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-696">
                Step 1: Text ScribeTok
              </h3>
              <p className="text-sm text-muted-foreground" data-id="element-697">
                Send any TikTok link to {phoneNumber} and get a transcript back
                in seconds
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-698">
              <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mb-4" data-id="element-699">
                <FileText size={24} className="text-primary" data-id="element-700" />
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-701">
                Step 2: Get Transcript
              </h3>
              <p className="text-sm text-muted-foreground" data-id="element-702">
                Receive a readable version of the TikTok content via SMS with a
                shareable link
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-703">
              <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mb-4" data-id="element-704">
                <Share2 size={24} className="text-primary" data-id="element-705" />
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-706">Step 3: Share Both</h3>
              <p className="text-sm text-muted-foreground" data-id="element-707">
                Share the TikTok AND transcript together with your partner—now
                they'll get it either way
              </p>
            </div>
          </div>
        </div>
        {/* SMS Card */}
        <div className="mb-12 animate-fade-in" style={{
        animationDelay: '500ms'
      }} data-id="element-708">
          <Card className="max-w-lg mx-auto" data-id="element-709">
            <CardContent className="p-6 flex flex-col items-center" data-id="element-710">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4" data-id="element-711">
                <Smartphone size={28} className="text-primary" data-id="element-712" />
              </div>
              <h2 className="text-xl font-medium mb-2" data-id="element-713">Text This Number</h2>
              <p className="text-sm text-muted-foreground mb-4" data-id="element-714">
                One text = shareable transcript your partner will actually read
              </p>
              <div className="flex items-center gap-2 px-4 py-2 bg-secondary rounded-full cursor-pointer mb-4 hover:bg-secondary/80 transition-colors" onClick={handleCopyNumber} data-id="element-715">
                <span className="font-medium" data-id="element-716">{phoneNumber}</span>
                {copied ? <Check size={16} className="text-green-500" data-id="element-717" /> : <Copy size={16} data-id="element-718" />}
              </div>
              <a href={smsHref} className="w-full mb-4" data-id="element-719">
                <Button size="lg" className="w-full" data-id="element-720">
                  <MessageSquare size={16} className="mr-2" data-id="element-721" />
                  Text Now
                </Button>
              </a>
              <p className="text-xs text-muted-foreground text-center" data-id="element-722">
                By texting us, you consent to receive automated reply messages.
                Message & data rates may apply.
              </p>
            </CardContent>
          </Card>
        </div>
        {/* Example Conversation */}
        <div className="mb-12 animate-fade-in" style={{
        animationDelay: '600ms'
      }} data-id="element-723">
          <h2 className="text-2xl font-bold mb-6" data-id="element-724">See How It Works</h2>
          <div className="bg-secondary/50 rounded-xl p-4 md:p-6 text-left max-w-xl mx-auto" data-id="element-725">
            <div className="space-y-4" data-id="element-726">
              <div className="flex justify-end" data-id="element-727">
                <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-728">
                  https://www.tiktok.com/@username/video/1234567890
                </div>
              </div>
              <div className="flex justify-start" data-id="element-729">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-730">
                  <p className="flex items-start gap-2" data-id="element-731">
                    <span className="text-xl flex-shrink-0" data-id="element-732">🎬</span>
                    <span data-id="element-733">
                      Thanks for using ScribeTok! You'll receive a transcript
                      shortly.
                    </span>
                  </p>
                </div>
              </div>
              <div className="flex justify-start" data-id="element-734">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-735">
                  <p className="flex items-start gap-2" data-id="element-736">
                    <span className="text-xl flex-shrink-0" data-id="element-737">✅</span>
                    <span data-id="element-738">Transcript ready!</span>
                  </p>
                  <p className="mt-2 ml-7" data-id="element-739">
                    "This new recipe hack is going to change your life. First,
                    take the avocado and slice it lengthwise..."
                  </p>
                  <div className="mt-3 ml-7 flex items-center" data-id="element-740">
                    <Button size="sm" variant="outline" className="rounded-full text-primary border-primary/30 bg-primary/10" data-id="element-741">
                      <Share2 size={14} className="mr-1.5" data-id="element-742" />
                      Share with transcript
                    </Button>
                  </div>
                  <p className="text-xs mt-3 text-primary font-medium ml-7" data-id="element-743">
                    share.scribetok.com/v/b70c860b-d7dc-4570-ae26-1235c94ee654
                  </p>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-744">
                <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-745">
                  <p className="flex items-start gap-2" data-id="element-746">
                    <span className="text-xl flex-shrink-0" data-id="element-747">👍</span>
                    <span data-id="element-748">Perfect! Sharing it with Alex now.</span>
                  </p>
                </div>
              </div>
              <div className="flex justify-start" data-id="element-749">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-750">
                  <p className="flex items-start gap-2" data-id="element-751">
                    <span className="text-xl flex-shrink-0" data-id="element-752">💯</span>
                    <span data-id="element-753">
                      Great! They'll see both the video AND the transcript. No
                      more "I'll watch it later" excuses!
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Native Share Example */}
        <div className="mb-16 animate-fade-in" style={{
        animationDelay: '650ms'
      }} data-id="element-754">
          <h2 className="text-2xl font-bold mb-6" data-id="element-755">Share Both, Not Just One</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-756">
            <div className="flex flex-col" data-id="element-757">
              <div className="bg-secondary/30 p-4 rounded-lg mb-4" data-id="element-758">
                <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-759">
                  <Share2 size={18} className="text-primary mr-2" data-id="element-760" />
                  The Old Way
                </h3>
                <div className="relative border border-border rounded-lg p-3 bg-background" data-id="element-761">
                  <div className="flex items-center gap-2 mb-3 text-sm" data-id="element-762">
                    <div className="w-8 h-8 rounded-full bg-gray-300 flex-shrink-0" data-id="element-763"></div>
                    <div data-id="element-764">
                      <p className="font-medium" data-id="element-765">You</p>
                      <p className="text-xs text-muted-foreground" data-id="element-766">Just now</p>
                    </div>
                  </div>
                  <div className="rounded-md overflow-hidden border border-border mb-2" data-id="element-767">
                    <div className="h-32 bg-gray-800 flex items-center justify-center" data-id="element-768">
                      <Play size={32} className="text-white/50" data-id="element-769" />
                    </div>
                  </div>
                  <p className="text-xs text-muted-foreground mb-3" data-id="element-770">
                    tiktok.com/@username/video/1234567890
                  </p>
                  <p className="text-sm italic text-red-500 mt-2" data-id="element-771">
                    ✗ Likely to be ignored
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-col" data-id="element-772">
              <div className="bg-secondary/30 p-4 rounded-lg mb-4" data-id="element-773">
                <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-774">
                  <Share2 size={18} className="text-primary mr-2" data-id="element-775" />
                  The ScribeTok Way
                </h3>
                <div className="relative border border-border rounded-lg p-3 bg-background" data-id="element-776">
                  <div className="flex items-center gap-2 mb-3 text-sm" data-id="element-777">
                    <div className="w-8 h-8 rounded-full bg-gray-300 flex-shrink-0" data-id="element-778"></div>
                    <div data-id="element-779">
                      <p className="font-medium" data-id="element-780">You</p>
                      <p className="text-xs text-muted-foreground" data-id="element-781">Just now</p>
                    </div>
                  </div>
                  <div className="rounded-md overflow-hidden border border-border mb-2" data-id="element-782">
                    <div className="h-32 bg-gray-800 flex items-center justify-center" data-id="element-783">
                      <Play size={32} className="text-white/50" data-id="element-784" />
                    </div>
                  </div>
                  <p className="text-xs text-muted-foreground mb-2" data-id="element-785">
                    tiktok.com/@username/video/1234567890
                  </p>
                  <div className="p-3 bg-primary/5 rounded-md border border-primary/20 mt-2" data-id="element-786">
                    <p className="text-sm font-medium text-primary mb-1" data-id="element-787">
                      📝 Transcript:
                    </p>
                    <p className="text-sm" data-id="element-788">
                      "This new recipe hack is going to change your life. First,
                      take the avocado and slice it lengthwise..."
                    </p>
                  </div>
                  <p className="text-sm italic text-green-500 mt-2" data-id="element-789">
                    ✓ They'll get it either way!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Perfect For Section */}
        <div className="mb-16 animate-fade-in" style={{
        animationDelay: '700ms'
      }} data-id="element-790">
          <h2 className="text-2xl font-bold mb-6" data-id="element-791">
            Perfect For When Your Partner...
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6" data-id="element-792">
            <Card className="bg-secondary/30 p-4 text-left" data-id="element-793">
              <div className="flex items-start gap-3" data-id="element-794">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-795">
                  <Clock size={20} className="text-primary" data-id="element-796" />
                </div>
                <div data-id="element-797">
                  <p className="font-medium" data-id="element-798">Is too busy</p>
                  <p className="text-sm text-muted-foreground" data-id="element-799">
                    Can't watch right now but can quickly read a text
                  </p>
                </div>
              </div>
            </Card>
            <Card className="bg-secondary/30 p-4 text-left" data-id="element-800">
              <div className="flex items-start gap-3" data-id="element-801">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-802">
                  <FileText size={20} className="text-primary" data-id="element-803" />
                </div>
                <div data-id="element-804">
                  <p className="font-medium" data-id="element-805">Prefers reading</p>
                  <p className="text-sm text-muted-foreground" data-id="element-806">
                    Some people just absorb information better through text
                  </p>
                </div>
              </div>
            </Card>
            <Card className="bg-secondary/30 p-4 text-left" data-id="element-807">
              <div className="flex items-start gap-3" data-id="element-808">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-809">
                  <Smartphone size={20} className="text-primary" data-id="element-810" />
                </div>
                <div data-id="element-811">
                  <p className="font-medium" data-id="element-812">Is in public</p>
                  <p className="text-sm text-muted-foreground" data-id="element-813">
                    No headphones or not appropriate to play audio
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
        {/* Comparison Table */}
        <div className="mb-16 animate-fade-in" style={{
        animationDelay: '800ms'
      }} data-id="element-814">
          <h2 className="text-2xl font-bold mb-6" data-id="element-815">
            The Relationship Difference
          </h2>
          <div className="overflow-hidden rounded-xl border border-border" data-id="element-816">
            <table className="w-full" data-id="element-817">
              <thead className="bg-secondary/50" data-id="element-818">
                <tr data-id="element-819">
                  <th className="p-4 text-left font-medium" data-id="element-820">Old Way</th>
                  <th className="p-4 text-left font-medium" data-id="element-821">ScribeTok Way</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-822">
                <tr data-id="element-823">
                  <td className="p-4 text-muted-foreground" data-id="element-824">
                    Just the TikTok link
                  </td>
                  <td className="p-4 text-primary font-medium" data-id="element-825">
                    TikTok + readable transcript together
                  </td>
                </tr>
                <tr data-id="element-826">
                  <td className="p-4 text-muted-foreground" data-id="element-827">
                    "Did you watch it?" fight
                  </td>
                  <td className="p-4 text-primary font-medium" data-id="element-828">
                    "Saw what you meant!" moment
                  </td>
                </tr>
                <tr data-id="element-829">
                  <td className="p-4 text-muted-foreground" data-id="element-830">
                    Needs sound/headphones
                  </td>
                  <td className="p-4 text-primary font-medium" data-id="element-831">
                    Read or watch - their choice
                  </td>
                </tr>
                <tr data-id="element-832">
                  <td className="p-4 text-muted-foreground" data-id="element-833">
                    Missed connection
                  </td>
                  <td className="p-4 text-primary font-medium" data-id="element-834">
                    Shared moments, even on busy days
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* Testimonials */}
        <div className="mb-16 animate-fade-in" style={{
        animationDelay: '900ms'
      }} data-id="element-835">
          <h2 className="text-2xl font-bold mb-6" data-id="element-836">What Couples Are Saying</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-837">
            <Card className="text-left" data-id="element-838">
              <CardContent className="p-6" data-id="element-839">
                <div className="flex items-center gap-3 mb-4" data-id="element-840">
                  <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center" data-id="element-841">
                    <Heart size={20} className="text-primary" data-id="element-842" />
                  </div>
                  <div data-id="element-843">
                    <p className="font-medium" data-id="element-844">Sarah & Mike</p>
                    <p className="text-sm text-muted-foreground" data-id="element-845">
                      Dating 3 years
                    </p>
                  </div>
                </div>
                <p className="text-muted-foreground italic" data-id="element-846">
                  "Mike never watched the TikToks I sent him. Now I share the
                  video WITH the transcript and he finally understands why I was
                  laughing so hard!"
                </p>
              </CardContent>
            </Card>
            <Card className="text-left" data-id="element-847">
              <CardContent className="p-6" data-id="element-848">
                <div className="flex items-center gap-3 mb-4" data-id="element-849">
                  <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center" data-id="element-850">
                    <Heart size={20} className="text-primary" data-id="element-851" />
                  </div>
                  <div data-id="element-852">
                    <p className="font-medium" data-id="element-853">Alex & Jordan</p>
                    <p className="text-sm text-muted-foreground" data-id="element-854">
                      Married 5 years
                    </p>
                  </div>
                </div>
                <p className="text-muted-foreground italic" data-id="element-855">
                  "I'm always in meetings and can't watch videos. Having the
                  transcript right there with the TikTok lets me stay connected
                  with what my partner finds funny or interesting."
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
        {/* CTA Section */}
        <div className="mb-12 animate-fade-in" style={{
        animationDelay: '1000ms'
      }} data-id="element-856">
          <Card className="bg-primary/5 border-primary/20" data-id="element-857">
            <CardContent className="p-8" data-id="element-858">
              <h2 className="text-2xl font-bold mb-4" data-id="element-859">
                Stop Being Ignored — Make Your TikToks Unmissable
              </h2>
              <p className="text-lg text-muted-foreground mb-6 max-w-xl mx-auto" data-id="element-860">
                Your partner doesn't have to choose between watching or
                ignoring. Give them both the video AND the transcript.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-861">
                <a href={smsHref} data-id="element-862">
                  <Button size="lg" className="w-full sm:w-auto" data-id="element-863">
                    <MessageSquare size={16} className="mr-2" data-id="element-864" />
                    Text Now
                  </Button>
                </a>
                <Link to="/features" data-id="element-865">
                  <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-866">
                    Explore More Features
                    <ArrowRight size={16} className="ml-2" data-id="element-867" />
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
        {/* Trust Indicators */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-muted-foreground mb-8 animate-fade-in" style={{
        animationDelay: '1100ms'
      }} data-id="element-868">
          <div className="flex items-center gap-2" data-id="element-869">
            <CheckCircle size={16} className="text-success" data-id="element-870" />
            <span data-id="element-871">Strengthening Relationships</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-872">
            <CheckCircle size={16} className="text-success" data-id="element-873" />
            <span data-id="element-874">10,000+ Couples Using</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-875">
            <CheckCircle size={16} className="text-success" data-id="element-876" />
            <span data-id="element-877">Free To Try</span>
          </div>
        </div>
        {/* Footer */}
        <div className="mt-8 border-t border-border/50 pt-4 text-xs text-muted-foreground" data-id="element-878">
          <p data-id="element-879">
            ScribeTok is a user-initiated SMS service. We do not send
            promotional messages. You can opt out at any time by replying STOP.
            Msg & data rates may apply.
          </p>
          <p className="mt-2" data-id="element-880">
            <Link to="/text/compliance" className="text-primary hover:underline" data-id="element-881">
              View full terms
            </Link>
          </p>
        </div>
      </div>
    </div>;
}